import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "infographics-container" }
const _hoisted_3 = { class: "infographics-header-block text-center" }
const _hoisted_4 = { class: "infographics-logo" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", null, "CONVORALLY", -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "step-tab" }
const _hoisted_8 = { class: "step-content" }
const _hoisted_9 = { class: "box-container" }
const _hoisted_10 = { class: "drive-heading text-center" }
const _hoisted_11 = { class: "uppercase-text" }
const _hoisted_12 = { class: "features-division" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "drive-wrap text-center" }
const _hoisted_16 = { class: "drive-first" }
const _hoisted_17 = { class: "element-wrap" }
const _hoisted_18 = { class: "element-highlight" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = { class: "drive-desc" }
const _hoisted_22 = { class: "element-wrap folder-wrap" }
const _hoisted_23 = { class: "bold-text" }
const _hoisted_24 = { class: "drive-features" }
const _hoisted_25 = { class: "drive-img" }
const _hoisted_26 = { class: "eye" }
const _hoisted_27 = { class: "or align-self-center" }
const _hoisted_28 = { class: "lowercase-text" }
const _hoisted_29 = { class: "rename" }
const _hoisted_30 = { class: "or align-self-center" }
const _hoisted_31 = { class: "lowercase-text" }
const _hoisted_32 = { class: "sub-folder" }
const _hoisted_33 = { class: "or align-self-center" }
const _hoisted_34 = { class: "lowercase-text" }
const _hoisted_35 = { class: "download" }
const _hoisted_36 = { class: "or align-self-center" }
const _hoisted_37 = { class: "lowercase-text" }
const _hoisted_38 = { class: "delete" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "drive-details text-center" }
const _hoisted_41 = { class: "drive-first" }
const _hoisted_42 = { class: "element-wrap max-img" }
const _hoisted_43 = { class: "element-highlight uppercase-text" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode()
const _hoisted_45 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_46 = { class: "drive-desc" }
const _hoisted_47 = { class: "element-wrap attach-file" }
const _hoisted_48 = { class: "bold-text" }
const _hoisted_49 = { class: "drive-features" }
const _hoisted_50 = { class: "drive-img" }
const _hoisted_51 = { class: "eye" }
const _hoisted_52 = { class: "or align-self-center" }
const _hoisted_53 = { class: "lowercase-text" }
const _hoisted_54 = { class: "rename" }
const _hoisted_55 = { class: "or align-self-center" }
const _hoisted_56 = { class: "lowercase-text" }
const _hoisted_57 = { class: "share" }
const _hoisted_58 = { class: "or align-self-center" }
const _hoisted_59 = { class: "lowercase-text" }
const _hoisted_60 = { class: "download" }
const _hoisted_61 = { class: "or align-self-center" }
const _hoisted_62 = { class: "lowercase-text" }
const _hoisted_63 = { class: "delete" }
const _hoisted_64 = { class: "step-move" }
const _hoisted_65 = { class: "step-prev" }
const _hoisted_66 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_67 = { class: "step-next" }
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_69 = { class: "final-container" }
const _hoisted_70 = { class: "final-block" }
const _hoisted_71 = { class: "container" }
const _hoisted_72 = { class: "final-wrap" }
const _hoisted_73 = { class: "convorally-moto" }
const _hoisted_74 = { class: "italic" }
const _hoisted_75 = { class: "final-img-wrap" }
const _hoisted_76 = /*#__PURE__*/_createVNode("p", null, "www. ", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("p", null, ".com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")
  const _component_TutorialStep = _resolveComponent("TutorialStep")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convoicon-blue.png`: 'timg/convoicon-blue.png' ,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _hoisted_5,
        _createVNode("h2", null, _toDisplayString(_ctx.$t('project_manager_app')), 1),
        _createVNode(_component_P, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('project_manager_description')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_TutorialStep)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/cloud-drive.png`: 'timg/cloud-drive.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('my_drive')), 1),
              _createVNode("p", null, _toDisplayString(_ctx.$t('my_drive_description')), 1)
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("img", {
                          src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/folder.png`: 'timg/folder.png' ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('tap_on')), 1),
                        _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('create')), 1),
                        _hoisted_19,
                        _hoisted_20,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('create_new_folder')), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, [
                        _createVNode("img", {
                          src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/folder-name.png.png`: 'timg/folder-name.png.png' ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.$t('give_folder_name')), 1)
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("p", null, "#" + _toDisplayString(_ctx.$t('folder_created')), 1)
                    ]),
                    _createVNode("div", _hoisted_24, [
                      _createVNode("div", _hoisted_25, [
                        _createVNode("ul", null, [
                          _createVNode("li", _hoisted_26, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/view-eye.png`: 'timg/view-eye.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("li", _hoisted_27, [
                            _createVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('or')), 1)
                          ]),
                          _createVNode("li", _hoisted_29, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/rename.png`: 'timg/rename.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("li", _hoisted_30, [
                            _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('or')), 1)
                          ]),
                          _createVNode("li", _hoisted_32, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/sub-folder.png`: 'timg/sub-folder.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("li", _hoisted_33, [
                            _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('or')), 1)
                          ]),
                          _createVNode("li", _hoisted_35, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/download.png`: 'timg/download.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("li", _hoisted_36, [
                            _createVNode("p", _hoisted_37, _toDisplayString(_ctx.$t('or')), 1)
                          ]),
                          _createVNode("li", _hoisted_38, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/delete.png`: 'timg/delete.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ])
                        ])
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.$t('folder_management_description')), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _createVNode("div", _hoisted_42, [
                        _createVNode("img", {
                          src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/upload.png`: 'timg/upload.png' ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('tap_on')), 1),
                        _createVNode("span", _hoisted_43, " +" + _toDisplayString(_ctx.$t('upload')), 1),
                        _hoisted_44,
                        _hoisted_45,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_files_device')), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_46, [
                      _createVNode("div", _hoisted_47, [
                        _createVNode("img", {
                          src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/attachment.png`: 'timg/attachment.png' ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.$t('choose_files_to_upload')), 1)
                    ]),
                    _createVNode("div", _hoisted_48, [
                      _createVNode("p", null, "#" + _toDisplayString(_ctx.$t('files_uploaded')), 1)
                    ]),
                    _createVNode("div", _hoisted_49, [
                      _createVNode("div", _hoisted_50, [
                        _createVNode("ul", null, [
                          _createVNode("li", _hoisted_51, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/view-eye.png`: 'timg/view-eye.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("li", _hoisted_52, [
                            _createVNode("p", _hoisted_53, _toDisplayString(_ctx.$t('or')), 1)
                          ]),
                          _createVNode("li", _hoisted_54, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/rename.png`: 'timg/rename.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("li", _hoisted_55, [
                            _createVNode("p", _hoisted_56, _toDisplayString(_ctx.$t('or')), 1)
                          ]),
                          _createVNode("li", _hoisted_57, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/share.png`: 'timg/share.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("li", _hoisted_58, [
                            _createVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('or')), 1)
                          ]),
                          _createVNode("li", _hoisted_60, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/download.png`: 'timg/download.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("li", _hoisted_61, [
                            _createVNode("p", _hoisted_62, _toDisplayString(_ctx.$t('or')), 1)
                          ]),
                          _createVNode("li", _hoisted_63, [
                            _createVNode("img", {
                              src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/delete.png`: 'timg/delete.png' ,
                              alt: ""
                            }, null, 8, ["src"])
                          ])
                        ])
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.$t('file_management_description')) + ". ", 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_64, [
              _createVNode("div", _hoisted_65, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep7 && _ctx.redirectToStep7(...args)))
                }, [
                  _hoisted_66
                ])
              ]),
              _createVNode("div", _hoisted_67, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep9 && _ctx.redirectToStep9(...args)))
                }, [
                  _hoisted_68
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_69, [
        _createVNode("section", _hoisted_70, [
          _createVNode("div", _hoisted_71, [
            _createVNode("div", _hoisted_72, [
              _createVNode("div", _hoisted_73, [
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/comment.png`: 'timg/comment.png' ,
                  alt: ""
                }, null, 8, ["src"]),
                _createVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('building_confidence_trust')) + " – ", 1),
                  _createVNode("span", _hoisted_74, _toDisplayString(_ctx.$t('one_convo_at_a_time')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_75, [
                _hoisted_76,
                _createVNode("img", {
                  src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convorally-text.png`: 'timg/convorally-text.png' ,
                  alt: ""
                }, null, 8, ["src"]),
                _hoisted_77
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}